import { validateDocumentCNPJ } from "utils/formatting/document";

const token = localStorage.getItem("@UltragazEmpresarial:accessToken");

export const removeSpecialCharacters = (e: string): string => {
  let value = e ?? "";

  value = value.trim();
  value = value.toUpperCase();
  value = value.normalize("NFD");
  value = value.replace(/\p{Mn}/gu, "");
  value = value.replace(/\s{2,}/g, " ");
  value = value.replace(/[0-9]/g, "");
  value = value.replace(/[&]/g, "9");
  value = value.replace(/ /g, "8");
  value = value.replace(/[^a-zA-Z0-9]/g, "");
  value = value.replace(/[9]/g, "&");
  value = value.replace(/[8]/g, " ");
  value = value.replace(/\s{2,}/g, " ");

  return value;
};

export const signOut = (redirectForgot = false): void => {
  const mfaToken = localStorage.getItem("@UltragazEmpresarial:X-Mfa-Hash");
  localStorage.clear();
  if (mfaToken) {
    localStorage.setItem("@UltragazEmpresarial:X-Mfa-Hash", mfaToken);
  }
  if (!redirectForgot) window.location.href = "/";
};

export const verifyUser = (props): void => {
  if (token === null) {
    localStorage.clear();
    const { history } = props;
    history.push("/acessar");
  }
};

export const cpfCnpjCursorAlign = (event, cursorStart, cursorEnd): void => {
  if (cursorStart && cursorEnd) {
    if (cursorStart === cursorEnd) {
      const { value } = event.target;
      const nextValue = value[cursorStart - 1];
      if (nextValue === "." || nextValue === "/" || nextValue === "-") {
        const newCursorStart = cursorStart + 1;
        const newCursorEnd = cursorEnd + 1;

        event.target.setSelectionRange(newCursorStart, newCursorEnd);
        return null;
      }

      event.target.setSelectionRange(cursorStart, cursorEnd);
    }
  }

  return null;
};

export const isObjectEmpty = (object): boolean => {
  if (JSON.stringify(object) === JSON.stringify({})) {
    return true;
  }
  return false;
};

export const validateCPF = (strCPF): boolean => {
  let retSum = 0;
  let restOfDivision;
  const exp = /\.|-|\//g;
  let newCpf = strCPF;
  newCpf = newCpf.toString().replace(exp, "");

  // Elimina CNPJs invalidos conhecidos
  if (
    newCpf.length !== 11 ||
    newCpf === "" ||
    newCpf === "00000000000" ||
    newCpf === "11111111111" ||
    newCpf === "22222222222" ||
    newCpf === "33333333333" ||
    newCpf === "44444444444" ||
    newCpf === "55555555555" ||
    newCpf === "66666666666" ||
    newCpf === "77777777777" ||
    newCpf === "88888888888" ||
    newCpf === "99999999999"
  ) {
    return false;
  }

  for (let i = 1; i <= 9; i += 1) {
    retSum += Number(newCpf.substring(i - 1, i)) * (11 - i);
  }
  restOfDivision = (retSum * 10) % 11;
  if (restOfDivision === 10 || restOfDivision === 11) restOfDivision = 0;
  if (restOfDivision !== Number(newCpf.substring(9, 10))) return false;
  retSum = 0;
  for (let i = 1; i <= 10; i += 1) {
    retSum += Number(newCpf.substring(i - 1, i)) * (12 - i);
  }
  restOfDivision = (retSum * 10) % 11;
  if (restOfDivision === 10 || restOfDivision === 11) restOfDivision = 0;
  if (restOfDivision !== Number(newCpf.substring(10, 11))) return false;
  return true;
};

export const validateCNPJ = (cnpj): boolean => validateDocumentCNPJ(cnpj ?? "");

export const getPropFromJSON = (prop, JSONString): any => {
  // Obviously this regex will only match Keys that have
  // String Values.
  const exp = new RegExp(`"${prop}":[^,}]*`);
  return JSONString.match(exp)[0].replace(`"${prop}":`, "");
};

export const formatBytes = (bytes): string => {
  let i = -1;
  const byteUnits = [" kB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"];
  do {
    bytes /= 1024;
    i += 1;
  } while (bytes > 1024);

  return Math.max(bytes, 0.1).toFixed(1) + byteUnits[i];
};
